<template>
    <div>
        <v-card style="margin-bottom:0.7rem;" flat>
            <v-row style="text-align:center;margin:0;">
                <!-- <v-col style="padding:6px;">
                    <div @click="clickFilter(-1)" :style="{borderBottom:(biz_sid === -1?'1px solid #5cbbf6':'1px solid #fff')}">
                        <div style="font-size:0.9rem;padding:0.4rem 0 0;color:#424242;">全部</div>
                        <div style="font-size:2rem;color:#424242;">{{statData.bs}}</div>
                    </div>
                </v-col> -->
                <!-- <v-col style="padding:6px;">
                    <div @click="clickFilter(0)" :style="{borderBottom:(biz_sid === 0?'1px solid #5cbbf6':'1px solid #fff')}">
                        <div style="font-size:0.9rem;padding:0.4rem 0 0;color:#424242;">待处理</div>
                        <div style="font-size:2rem;color:#FF8A80;">{{statData.b0}}</div>
                    </div>
                </v-col>
                <v-col style="padding:6px;">
                    <div @click="clickFilter(2)" :style="{borderBottom:(biz_sid === 2?'1px solid #5cbbf6':'1px solid #fff')}">
                        <div style="font-size:0.9rem;padding:0.4rem 0 0;color:#424242;">处理中</div>
                        <div style="font-size:2rem;color:#FB8C00;">{{statData.b2}}</div>
                    </div>
                </v-col>
                <v-col style="padding:6px;">
                    <div @click="clickFilter(4)" :style="{borderBottom:(biz_sid === 4?'1px solid #5cbbf6':'1px solid #fff')}">
                        <div style="font-size:0.9rem;padding:0.4rem 0 0;color:#424242;">已完成</div>
                        <div style="font-size:2rem;color:#9E9E9E;">{{statData.b4}}</div>
                    </div>
                </v-col> -->
                <v-col style="padding:6px;">
                    <div @click="clickFilter(-2)" :style="{borderBottom:(biz_sid === -2?'1px solid #5cbbf6':'1px solid #fff')}" style="cursor: pointer;">
                        <div style="font-size:0.9rem;padding:0.4rem 0 0;color:#424242;">未完成</div>
                        <div style="font-size:2rem;color:#FF8A80;">{{(statData.b0 + statData.b2)}}</div>
                    </div>
                </v-col>
                <v-col style="padding:6px;">
                    <div @click="clickFilter(4)" :style="{borderBottom:(biz_sid === 4?'1px solid #5cbbf6':'1px solid #fff')}" style="cursor: pointer;">
                        <div style="font-size:0.9rem;padding:0.4rem 0 0;color:#424242;">已完成</div>
                        <div style="font-size:2rem;color:#67C23A;">{{statData.b4}}</div>
                    </div>
                </v-col>
                <v-col style="padding:6px;">
                    <div @click="goCurOrderStat" :style="{borderBottom:('1px solid #fff')}" style="cursor: pointer;">
                        <div style="font-size:0.9rem;padding:0.4rem 0 0;color:#424242;">统计</div>
                        <div style="font-size:2rem;color:#9E9E9E;"><i class="fa fa-bar-chart" aria-hidden="true"></i></div>
                    </div>
                </v-col>
            </v-row>
        </v-card>
        <div v-if="loading">
            <v-skeleton-loader ref="skeleton" type="article" class="mx-auto" style="margin-bottom:0.5rem;"></v-skeleton-loader>
            <v-skeleton-loader ref="skeleton" type="article" class="mx-auto" style="margin-bottom:0.5rem;"></v-skeleton-loader>
            <v-skeleton-loader ref="skeleton" type="article" class="mx-auto" style="margin-bottom:0.5rem;"></v-skeleton-loader>
            <v-skeleton-loader ref="skeleton" type="article" class="mx-auto" style="margin-bottom:0.5rem;"></v-skeleton-loader>
            <v-skeleton-loader ref="skeleton" type="article" class="mx-auto" style="margin-bottom:0.5rem;"></v-skeleton-loader>
        </div>
        <v-card v-else flat style="background: #eee">
          <div v-for="(item,index) in list" :key="index" >
            <OrderCard :orderInfo="item" flat />
          </div>
        </v-card>
        <ListFooter v-if="!loading && list.length === 0" :count="list.length" />
    </div>
</template>

<script>
import OrderCard from '../OrderCard'
import ListFooter from '../../../components/ListFooter'
export default {
  components: { OrderCard, ListFooter },
  props: {
  },
  data() {
    return {
      loading: true,
      list: [],
      statData: {
        bs: 0,
        b0: 0,
        b2: 0,
        b4: 0
      },
      biz_sid: -2,
      listFilter: {
        search_content: '',
        search_fields: ['GZ_TITLE'],
        gz_date_time: [],
        pagination: {
          limit: 30,
          page: 1
        },
        biz_sid: -2
      }
    }
  },
  watch: {
  },
  computed: {
  },
  mounted() {
    this.initData();
  },
  created() {
  },
  methods: {
    statOrderCount() {
      var that = this
      that.$api.bz.statGzOrderCount().then(res => {
        if (!res.success) {
          console.log('获取报障统计数据失败', res);
          return
        }
        that.statData = res.data
        that.statData.bs = that.statData.b0 + that.statData.b2 + that.statData.b4
      })
    },
    initData() {
      var that = this
      // that.loading = true
      that.statOrderCount();
      that.listFilter.biz_sid = that.biz_sid
      that.$api.bz.queryOrderList({ str_filter: JSON.stringify(that.listFilter) }).then(res => {
        if (!res.success) {
          console.log('获取报障工单列表失败', res);
          return
        }
        var data = res.data
        that.list = data.list
        that.loading = false
      })
    },
    clickFilter(val) {
      var that = this
      that.biz_sid = val
      that.initData();
    },
    goCurOrderStat() {
      this.$router.goPage('/CurOrderStat')
    }
  }
}
</script>

<style scoped>
</style>
